import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { MessageCircle, Zap } from 'lucide-react';
import { CosmicPurchases } from './CosmicPurchases';
import { UniversalCommentModule } from '../../comments';

const LIFECYCLE_STEPS = [
  { id: 'Prospecto', labelKey: 'prospect' },
  { id: 'Envio de linea', labelKey: 'lineShipping' },
  { id: 'Activo', labelKey: 'active' },
  { id: 'Portabilidad', labelKey: 'portability' },
  { id: 'Deuda', labelKey: 'debt' },
  { id: 'Predesactivacion', labelKey: 'preDeactivation' },
  { id: 'Desactivado', labelKey: 'deactivated' },
];

// Fase 5.15 -- presentacional: `user` / `toast` llegan por prop de `ClientsView` (sólo se
// reenvían a `UniversalCommentModule`).
export default function CosmicClient({ op, onClose, globalAction, rightWidth, startResizeRight, onToggleWhatsApp, user, toast }) {
  const { t } = useTranslation('client');
  const [showPurchases, setShowPurchases] = useState(false);

  if (!op && !globalAction) return null;

  const isGlobal = !!globalAction;
  const title = isGlobal
    ? (globalAction === 'activacion' ? t('cosmicClient.titles.newActivation') : globalAction === 'recarga' ? t('cosmicClient.titles.recharge') : t('cosmicClient.titles.portability'))
    : (op?.holder || t('cosmicClient.noName'));

  const planTag = isGlobal ? null : op?.plan;

  return ReactDOM.createPortal(
    <>
      <div
        className="op-detail-panel"
        style={{
          position: 'fixed',
          top: 0, right: 0, bottom: 0, width: rightWidth || 600,
          zIndex: 999999,
          background: '#111113',
          borderLeft: '1px solid rgba(255,255,255,0.08)',
          display: 'flex', flexDirection: 'column',
          animation: 'slideFromRight 0.22s cubic-bezier(0.16,1,0.3,1)'
        }}
      >
        <div
          className="op-resizer-zone"
          style={{
            position: 'absolute', left: '-6px', top: 0, bottom: 0, width: '12px',
            cursor: 'ew-resize', zIndex: 1000000, display: 'flex', alignItems: 'center',
            justifyContent: 'center', pointerEvents: 'all'
          }}
        >
          <div
            className="op-resizer-handle"
            onPointerDown={startResizeRight}
            style={{
              position: 'absolute', bottom: '125px', left: '50%', transform: 'translateX(-50%)',
              width: '8px', height: '48px', borderRadius: 'var(--radius-sm)', background: 'rgba(255, 255, 255, 0)',
              transition: 'background 0.2s, opacity 0.2s', cursor: 'ew-resize', pointerEvents: 'all'
            }}
          />
        </div>

        <div className="op-panel-header" style={{ padding: 'var(--space-3)' }}>
          {planTag && (
            <span className="op-header-product-tag" style={{
              color: '#3b82f6', borderColor: '#3b82f6', backgroundColor: '#3b82f615'
            }}>{planTag}</span>
          )}
          <div className="op-panel-title" style={{ color: '#fff', textTransform: isGlobal ? 'capitalize' : 'none' }}>{title}</div>
          <button className="op-panel-close" onClick={onClose}>✕</button>
        </div>

        <div className="op-panel-tabs" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 var(--space-3) var(--space-3) var(--space-3)' }}>
          <div style={{ display: 'flex', gap: 'var(--space-2)', alignItems: 'center' }}>
            <button className="op-panel-tab active">{isGlobal ? t('cosmicClient.tabForm') : t('cosmicClient.tabClient')}</button>
            <button
              onClick={onToggleWhatsApp}
              title={t('cosmicClient.messageTooltip')}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: 'rgba(255, 255, 255, 0.35)',
                padding: 'var(--space-1)', borderRadius: 'var(--radius-sm)', display: 'flex', alignItems: 'center',
                justifyContent: 'center', transition: 'all 0.2s'
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)'; e.currentTarget.style.color = 'rgba(255, 255, 255, 0.85)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'none'; e.currentTarget.style.color = 'rgba(255, 255, 255, 0.35)'; }}
            >
              <MessageCircle size={15} />
            </button>
          </div>
        </div>

        <div className="op-panel-body" style={{ flex: 1, overflowY: 'auto', padding: 'var(--space-3)' }}>
          {isGlobal && globalAction === 'recarga' ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
              <button
                onClick={() => setShowPurchases(true)}
                style={{
                  background: '#9333ea', color: '#fff', border: 'none', padding: 'var(--space-3) var(--space-5)',
                  borderRadius: 'var(--radius-md)', fontSize: '15px', fontWeight: 600, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', gap: 'var(--space-2)', justifyContent: 'center'
                }}
              >
                <Zap size={18} />
                {t('cosmicClient.rechargeButton')}
              </button>
            </div>
          ) : (
            <div className="cosmic-client-dashboard">
              {/* Profile Header */}
              <div className="ccd-profile-header">
                <div className="ccd-avatar">
                  {op?.holder ? op.holder.charAt(0).toUpperCase() : 'C'}
                </div>
                <div className="ccd-profile-info">
                  <h2 className="ccd-name">{op?.holder || t('cosmicClient.noName')}</h2>
                  <div className="ccd-contact-row">
                    <span className="ccd-phone">{op?.line || t('cosmicClient.noNumber')}</span>
                    <span className="ccd-dot">•</span>
                    <span className="ccd-email">{op?.email || 'contacto@usuario.com'}</span>
                  </div>
                  <div className="ccd-meta-row">
                    <span className="ccd-id">ID: {op?.id || 'C-1002'}</span>
                    <span className="ccd-dot">•</span>
                    <span className="ccd-date">{t('cosmicClient.clientSince')} {op?.created_at ? new Date(op.created_at).toLocaleDateString('es-MX', { day: 'numeric', month: 'long', year: 'numeric' }) : '12 de octubre de 2023'}</span>
                  </div>
                </div>
              </div>

              <div className="ccd-divider"></div>

              {/* Lifecycle Pipeline */}
              <div className="ccd-lifecycle-wrapper">
                <div className="ccd-lifecycle">
                  {LIFECYCLE_STEPS.map((step, idx) => {
                    const currentStatus = op?.status?.toLowerCase() || 'activo';
                    let isActive = false;

                    if (step.id.toLowerCase() === 'predesactivacion' && currentStatus === 'pre-desactivado') isActive = true;
                    else if (currentStatus.includes(step.id.toLowerCase())) isActive = true;
                    else if (currentStatus === 'activo' && step.id === 'Activo') isActive = true;

                    return (
                      <div key={idx} className={`ccd-step ${isActive ? 'active' : ''}`}>
                        <span className="ccd-step-text">{t(`cosmicClient.lifecycle.${step.labelKey}`)}</span>
                        <div className="ccd-chevron"></div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="ccd-divider"></div>

              {/* Unified Dashboard Card */}
              <div className="ccd-unified-card">
                {/* Left Column: Plan */}
                <div className="ccd-card-column ccd-plan-card">
                  <h4 className="ccd-card-title">{t('cosmicClient.currentPlan')}</h4>
                  <div className="ccd-plan-details">
                    <div className="ccd-plan-name-row">
                      <span className="ccd-plan-name">{op?.plan || 'Solar'}</span>
                      <span className="ccd-plan-gigas">{op?.total_gb || 0} GB</span>
                    </div>
                    <div className="ccd-plan-price">
                      ${(() => {
                        const p = (op?.plan || '').toLowerCase();
                        if (p.includes('sky')) return '55.00';
                        if (p.includes('gravity')) return '80.00';
                        if (p.includes('comet')) return '129.00';
                        if (p.includes('galaxy')) return '150.00';
                        if (p.includes('star')) return '155.00';
                        if (p.includes('lunar')) return '251.00';
                        if (p.includes('earth')) return '374.00';
                        if (p.includes('solar')) return '597.00';
                        return '0.00';
                      })()}
                      <span className="ccd-price-period">{t('cosmicClient.perMonth')}</span>
                    </div>
                    <div className="ccd-plan-renewal">
                      {t('cosmicClient.renewal')}: {op?.recharge_date ? new Date(new Date(op.recharge_date).getTime() + (30 * 24 * 60 * 60 * 1000)).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' }) : t('cosmicClient.nextMonth')}
                    </div>
                  </div>
                </div>

                {/* Right Column: Usage */}
                <div className="ccd-card-column ccd-usage-card" style={{ paddingLeft: 'var(--space-3)' }}>
                  <h4 className="ccd-card-title">{t('cosmicClient.monthlyConsumption')}</h4>
                  <div className="ccd-usage-content">
                    <div className="ccd-donut-wrapper">
                      {(() => {
                        const consumed = parseFloat(op?.consumption_gb || 0);
                        const total = parseFloat(op?.total_gb || 100);
                        let percentage = total > 0 ? (consumed / total) * 100 : 0;
                        if (percentage > 100) percentage = 100;
                        const remaining = 100 - percentage;

                        const strokeDasharray = `${remaining} ${percentage}`;

                        return (
                          <svg viewBox="0 0 36 36" className="ccd-donut-chart">
                            <path
                              className="ccd-donut-bg"
                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                            />
                            <path
                              className="ccd-donut-fill"
                              strokeDasharray={strokeDasharray}
                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                            />
                            <text x="18" y="20.5" className="ccd-donut-text">
                              {Math.round(remaining)}%
                            </text>
                          </svg>
                        );
                      })()}
                    </div>

                    <div className="ccd-usage-stats">
                      <div className="ccd-stat-row">
                        <span className="ccd-stat-label">{t('cosmicClient.data')}</span>
                        <span className="ccd-stat-value">{op?.consumption_gb || 0} / {op?.total_gb || 0} GB</span>
                      </div>
                      <div className="ccd-stat-row">
                        <span className="ccd-stat-label">{t('cosmicClient.minutes')}</span>
                        <span className="ccd-stat-value">120 / {t('cosmicClient.unlimited')}</span>
                      </div>
                      <div className="ccd-stat-row">
                        <span className="ccd-stat-label">{t('cosmicClient.sms')}</span>
                        <span className="ccd-stat-value">45 / {t('cosmicClient.unlimited')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Unified Comments Module -- solo aplica a una línea ya existente; en modo global
                  (globalAction 'activacion'/'portabilidad', op === null) no hay línea a la cual
                  colgar comentarios. Sin este guard, `op.line` tronaba el error boundary. */}
              {op?.line && (
                <div style={{ marginTop: 'var(--space-5)', height: '600px' }}>
                    <UniversalCommentModule docId={`cosmic_${op.line}`} title={t('cosmicClient.commentsTitle')} user={user} toast={toast} />
                </div>
              )}
            </div>
          )}
        </div>

      </div>

      {showPurchases && (
        <CosmicPurchases
          onClose={() => setShowPurchases(false)}
          mainPanelWidth={rightWidth || 600}
        />
      )}
    </>,
    document.body
  );
};
